import { IKeyValuePair } from '../models/common/IKeyValuePair';

export function getGlobalValue(mapping: Partial<IKeyValuePair>) {
	if (mapping.value) {
		return mapping.value;
	}
    // Stubbed at the moment
	return mapping.key;
}